import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { isEmpty, map } from "lodash";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import "react-rangeslider/lib/index.css";
import notes from "../../assets/images/rsicons/notes.png";
import follow from "../../assets/images/rsicons/follow-up.png";
import phonelog from "../../assets/images/rsicons/phone-log.png";
import emaillog from "../../assets/images/rsicons/email-log.png";
import { Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import CallLog from "./tab-comp/CallLog";
import EmaillLog from "./tab-comp/EmaillLog";
import SmsLog from "./tab-comp/SmsLog";
import AppointmentLog from "./tab-comp/AppointmentLog";
import LeadNote from "./tab-comp/LeadNote";
import FollowLead from "./tab-comp/FollowLead";
import LeadListing from "./tab-comp/Lead-listing";

import EditLead from "./forms/lead-edit";
import { Container,Row,Col, Card, CardBody, Table, Collapse, FormGroup, Label, Button, ButtonGroup, Nav, NavItem, NavLink,
  TabContent, TabPane, InputGroup, Offcanvas, OffcanvasHeader, OffcanvasBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input} from "reactstrap";
import classnames from "classnames";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from 'axios'
import Moment from "react-moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLeadDetail, getAllActLeadTab,
  convertLeadIntoClient,
  convertLeadIntoContact,
  getLeadProject,
  getCampaignEmailList,
  getCampLeadList,
  addCampaignEmailList, getEmailListTarget, getUserDetail
} from "../../store/actions";
import RsLink from "components/buttons/rsLink";
import LeadDetailMenu from "./menu/lead-detail-menu";

import LeadDetailLeft from "./forms/lead-detail-left";
import SaveButton from "components/buttons/save";
import { API_URL } from "helpers/app_url";
import LeadMessage from "./tab-comp/LeadMessage";
import RsAdNew from "components/buttons/Adnew";
import SafeHTML from "components/buttons/SafeHTML";
import ComposeLeadMail from "components/dropdowns/ComposeEmailLead";
import moment from "moment";
import SafeField from "helpers/SafeField";
import EmailExpand from "components/dropdowns/EmailExpand";
import EmailActivityList from "components/dropdowns/EmailExpand";
import { hasPermission } from "helpers/checkPermission";
import Permission from "pages/Settings/permission";
import NoAccess from "components/NoAccess";

class leadDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      isMobile: window.innerWidth < 768,
      open: false,
      isRight: false,
      isRight2: false,
      isRight3: false,
      isBackdrop: false,
      col9: false,
      col15: false,
      col10: false,
      col11: false,
      col12: true,
      selectedGroup: null,
      activeTab: "1",
      verticalActiveTab: "1",
      volume: 0,
      leadData: [],
      buyersQuestions: [],
      sources: [],
      leadStatus: [],
      leadTypes: [],
      groupDrops: [],
      maritalStat: [],
      prefMediums: [],
      likelihoods: [],
      selectedEmails: [],
      titles: [],
      total: 0,
      numbers: {
        comp1: 0,
        comp2: 0,
        comp3: 0,
        comp4: 0,
        comp5: 0,
      },
      leadId: "",
      Id: "",
      ccTab:"1",
      showCompose: false,
      showReply:false,
      showForward: false
    };
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleRightCanvas2 = this.toggleRightCanvas2.bind(this);
    this.toggleRightCanvas3 = this.toggleRightCanvas3.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.t_col9 = this.t_col9.bind(this);
    this.t_col10 = this.t_col10.bind(this);
    this.t_col11 = this.t_col11.bind(this);
    this.t_col12 = this.t_col12.bind(this);
    this.t_col15 = this.t_col15.bind(this);
    this.handleSelectGroup = this.handleSelectGroup.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleAddCollection = this.toggleAddCollection.bind(this);
     this.handleProTypeSubmit = this.handleProTypeSubmit.bind(this)
  }
  handleProTypeSubmit(value) {
    const payload = {
        agentId: parseInt(value.agentId),
        emailListTypeId:parseInt(value.emailListTypeId),
        campaignEmailListName:value.campaignEmailListName,
        emailListTargetId:parseInt(value.emailListTargetId),
        campaignEmailListDesc:value.campaignEmailListDesc,
        isActive:true
    }
     this.props.addCampaignEmailList(payload , (status) => {
      if (status === true) {
        this.toggleAddCollection();
      }
    });
  }
 toggleAddCollection() {
    this.setState({ isAddCollection: !this.state.isAddCollection });
  }
  toggleRightCanvas() {
    this.setState({ isRight: !this.state.isRight });
  }
  toggleRightCanvas2() {
    this.setState({ isRight2: !this.state.isRight2 });
  }

  toggleRightCanvas3() {
    this.setState({ isRight3: !this.state.isRight3 });
  }

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  handleOnChange = value => {
    this.setState({
      volume: value,
    });
  };
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  cctoggle(tab) {
    if (this.state.ccTab !== tab) {
      this.setState({
        ccTab: tab,
      });
    }
  }
  handleSelectGroup = selectedGroup => {
    this.setState({ selectedGroup });
  };
  t_col9() {
    this.setState({
      col9: !this.state.col9,
      col10: false,
      col11: false,
      col12: false,
      col15: false,
    });
  }

  t_col10() {
    this.setState({
      col10: !this.state.col10,
      col9: false,
      col11: false,
      col12: false,
      col15: false,
    });
  }

  t_col11() {
    this.setState({
      col11: !this.state.col11,
      col9: false,
      col10: false,
      col12: false,
      col15: false,
    });
  }
  t_col12() {
    this.setState({
      col12: !this.state.col12,
      col11: false,
      col9: false,
      col10: false,
      col15: false,
    });
  }
  t_col15() {
    this.setState({
      col15: !this.state.col15,
      col11: false,
      col9: false,
      col10: false,
      col12: false,
    });
  }
  componentDidMount() {
    const {
      match: { params },
      onGetLeadDetail,
      onGetAllActLead,
      onGetLeadProject,
      onGetCampaignEmailList,
      onGetCampLeadList,
      onGetEmailListTarget,
   
    } = this.props;

    if (params && params.id && params.leadId) {
      onGetLeadDetail(params.leadId);
      onGetAllActLead(params.id);
      onGetLeadProject(params.id)
      onGetCampaignEmailList(localStorage.getItem('userId')),
      onGetEmailListTarget(localStorage.getItem('userId'));
      onGetCampLeadList(localStorage.getItem('userId'),params.id);
      //onGetUserDetail(localStorage.getItem('userId'));
      this.setState({ leadId: params.leadId });
      this.setState({ Id: params.id });
    }

     window.addEventListener("resize", () => {
        this.setState({ isMobile: window.innerWidth < 768 });
  });
   
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.leads !== this.props.leads) {
      this.setState({
        activeTab: this.props.leads?.onlyInterestedPreConsProject ? "9" : "1"
      });
    }
    //
  }
  handleSubmit = (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str =  `Bearer ${token}`;
    toast.loading("Please wait...")
       const formattedData = {
        agentId: parseInt(values.agentId),
        campaignEmailListId: parseInt(campaignId),
        firstName: values.firstName,
        lastName: values.lastName,
        emailAddress: values.emailAddress,
        contactNumber: values.contactNumber,
        clientId: 0, 
        leadId: parseInt(values.leadId), 
        contactId: 0, 
        isUnsubscribed: false,
        isActive: true
    };
    
    axios.post(`${API_URL}CampaignEmailListItem`, formattedData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': str,
      },
    })
        .then(response => response.json())
        .then(data => {
          toast.dismiss();
          if (data.success) {
              toast.success("Lead added into collection successfully!");
          } else {
              toast.error("Failed to add lead into  collection. Please try again.");
          }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("Error occurred while updating. Please try again.");
      })
      .finally(() => {
        toast.dismiss();
        setSubmitting(false); 
      });
  };
 handleCheckboxChange = (emailId) => {
    this.setState((prevState) => {
      const selectedEmails = [...prevState.selectedEmails];
      if (selectedEmails.includes(emailId)) {
        selectedEmails.splice(selectedEmails.indexOf(emailId), 1);
      } else {
        selectedEmails.push(emailId);
      }
      return { selectedEmails };
    });
  };
    handleDelete = async () => {
      const { selectedEmails } = this.state;
    
      if (selectedEmails.length === 0) {
        Swal.fire({
          title: 'No emails selected',
          text: 'Please select emails to delete.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        return;
      }
      
     
      //const confirmed = window.confirm("Are you sure you want to delete the selected emails?");
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this action!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      });
      if (result.isConfirmed) {
        try {
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          };
          for (let emailId of selectedEmails) {
            const url = `${API_URL}Gmail/DeleteGoogleEmail/${this.state?.agentData?.agentId}/${emailId}/1`;
            await axios.get(url, { headers });
            this.setState((prevState) => {
              const updatedMails = prevState.inboxMails.filter(
                (inbox) => inbox.messageID !== emailId
              );
              return { inboxMails: updatedMails };
            });
          }
          this.setState({ selectedEmails: [] });
    
        } catch (error) {
          console.error("Error deleting emails", error);
          alert("An error occurred while deleting emails.");
        }
      }
    };
  
 fetchInboxMails(agentId, email,page) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
  
      axios.get(`${API_URL}Gmail/GetMailFromByFromEmailPagination/${agentId}/${email}/${page}/20/false/false`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(secondResponse => {
        
        
        this.setState({
          inboxMails: secondResponse.data.items, 
          totalPages: secondResponse.data.totalPages || 1, 
          isLoading: false,
          
        totalEmails:secondResponse.data.totalPages 
        });
      })
      .catch(error => {
        console.error('Error fetching data from second API:', error);
        this.setState({ isLoading: false });
      });
    }
  render() {
    const {leads, onConvertLeadToClient,onCovertLeadIntoContact, projects, campaignemaillists, camplists, onGetCampLeadList, emaillisttargets, userdetail} = this.props;
    const { activities } = this.props;
    const allLocal = localStorage.getItem("localData");
    const localization = JSON.parse(allLocal);
    const userModule = localStorage.getItem("userModule");
    const leadQualificationPoints = leads?.leadQualificationPoints;
    const formattedPoints = leadQualificationPoints?.toFixed(2);
    const seriesData = [formattedPoints];
    const {  onGetAllActLead, onGetLeadProject,
      onGetCampaignEmailList,
      onGetEmailListTarget, } = this.props;

    const { inboxMails, selectedEmails, showCompose, showReply, showForward } = this.state;
    
    return (
      
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Lead Detail | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm="3" className="pe-0">
                {this.state.isMobile && (
                <Row className="project-header">
                <Col sm='8'>
                  <Breadcrumbs
                    title={this.props.t("Lead")}
                    breadcrumbItem={this.props.t("Lead Detail")}
                  />
                
                  </Col>
                  <Col sm='4'>
                      <h2>{leads.firstName + " " + leads.lastName }</h2>
                  </Col>
                  </Row>
                )}
                <LeadDetailLeft leads={leads} userdetail={userdetail} isMobile={this.state.isMobile} />
              </Col>
              <Col sm="9" className="ps-0 pe-0">
                 {!this.state.isMobile && (
                  <>
              <Row className="project-header">
                <Col sm='8'>
            <Breadcrumbs
              title={this.props.t("Lead")}
              breadcrumbItem={this.props.t("Lead Detail")}
            />
           
            </Col>
            <Col sm='4'>
                <h2>{leads.firstName + " " + leads.lastName }</h2>
            </Col>
            </Row>
                 <LeadDetailMenu leads={leads} />  
                 </>
                 )}     
                    
                <Row>
                  <Col xl="12">
                 
                  {this.state.isMobile ? (
                    <Card>
                      <CardBody>
                          <div className="mobile-menu">
                            <h6>Select Menu</h6>
                  <select
                      className="form-select mb-3"
                      value={this.state.activeTab}
                      onChange={(e) => this.toggle(e.target.value)}
                    >
                      {leads?.onlyInterestedPreConsProject && (
                        <option value="9">Projects</option>
                      )}
                      <option value="1">All</option>
                      {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                        <option value="13">Message</option>
                      )}
                      <option value="3">Notes</option>
                      <option value="4">Follow-ups</option>
                      <option value="5">Logs</option>
                      <option value="8">Listings</option>
                      <option value="11">Collections</option>
                      {!leads?.onlyInterestedPreConsProject && (
                        <option value="9">Projects</option>
                      )}
                    </select> 
                  
                    </div>
                      </CardBody>
                    </Card>
                   
                  ) : (
                  <Nav
                                    tabs
                                    className="lead-tab mt-10 mb-10"
                                  >
                                      {leads?.onlyInterestedPreConsProject ?
                                        <NavItem>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                              active: this.state.activeTab === "9",
                                            })}
                                            onClick={() => {
                                              this.toggle("9");
                                              onGetLeadProject(this.props.match.params.id)
                                            }}
                                          >
                                            <span className="">
                                              {this.props.t("Projects")}
                                            </span>
                                          </NavLink>
                                        </NavItem>
                                      : ''  }
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "1",
                                        })}
                                        onClick={() => {
                                          this.toggle("1");
                                          this.props.onGetAllActLead(this.props.match.params.id);
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("All")}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                     <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "16",
                                        })}
                                        onClick={() => {
                                          this.toggle("16");
                                            this.fetchInboxMails(userdetail?.agentId, leads?.email, 1);
                                        }}
                                      >
                                        <span className="">{this.props.t("Inbox")}</span>
                                      </NavLink>
                                    </NavItem>
                                    {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "13",
                                        })}
                                        onClick={() => {
                                          this.toggle("13");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Message")}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                    )}
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "3",
                                        })}
                                        onClick={() => {
                                          this.toggle("3");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Notes")}
                                        </span>
                                      </NavLink>
                                    </NavItem>

                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "4",
                                        })}
                                        onClick={() => {
                                          this.toggle("4");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Follow-ups")}
                                        </span>
                                      </NavLink>
                                    </NavItem>

                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "5",
                                        })}
                                        onClick={() => {
                                          this.toggle("5");
                                        }}
                                      >
                                        <span className="k">
                                          {this.props.t("Logs")}
                                        </span>
                                      </NavLink>
                                    </NavItem>

                                  

                                    {/* <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "8",
                                        })}
                                        onClick={() => {
                                          this.toggle("8");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Listings")}
                                        </span>
                                      </NavLink>
                                    </NavItem> */}
                                  
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "11",
                                        })}
                                        onClick={() => {
                                          this.toggle("11");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Collections")}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                    {!leads?.onlyInterestedPreConsProject ?
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.activeTab === "9",
                                        })}
                                        onClick={() => {
                                          this.toggle("9");
                                        }}
                                      >
                                        <span className="">
                                          {this.props.t("Projects")}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                              : ''  }
                    </Nav>
                  )}
                    <Card>
                     {hasPermission("RealtorLeadsActivities", [
  "Add",
  "View",
  "Edit",
  "Delete"
]) ? (
                    <TabContent
                      activeTab={this.state.activeTab}
                      className="p-3 text-muted"
                    >
                        <TabPane tabId="9">
                        
                        <div className="table-rep-plugin">
                          <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                          >
                            <Table
                              id="tech-companies-1"
                              className="table table-striped table-bordered"
                            >
                              <Thead>
                                <Tr>
                                  <Th>{this.props.t("Date")}</Th>
                                  <Th>
                                    {this.props.t("Project")}
                                  </Th>
                                  <Th>
                                    {this.props.t("Source")}
                                  </Th>
                                </Tr>
                              </Thead>
                             
                             <Tbody>
                              {projects && projects.length > 0 ? (
                                projects.map((project, prokey) => (
                                  <Tr key={prokey}>
                                    <Th>
                                      <Moment format="D MMM YY">{project.interestedProjectDate}</Moment>
                                    </Th>
                                    <Th>
                                      <span className="co-name">{project?.projectInfo?.projectName}</span>
                                    </Th>
                                    <Th>
                                      <Link to={`/pre-construction/campaign/current-prospects/${project?.projectInfo?.projectId}`}>
                                        View Detail
                                      </Link>
                                    </Th>
                                  </Tr>
                                ))
                              ) : (
                                <Tr>
                                  <Td colSpan="3" style={{ textAlign: "center" }}>
                                    No projects found
                                  </Td>
                                </Tr>
                              )}
                           
                              </Tbody>
                            </Table>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane tabId="1">
                        <div className="mb-5 h4 card-title">
                          All Activities
                        </div>
                         {activities && activities.length > 0 ? (
                        <ul className="verti-timeline list-unstyled">
                          {map(
                            activities,
                            (allactivity, allactkey) => (
                              <li
                                className="event-list eventlist"
                                key={"_allact_" + allactkey}
                              >
                                <div className="event-timeline-dot">
                                  {(() => {
                                    if (
                                      allactivity.activitySubType ==
                                        8 ||
                                      allactivity.activitySubType ==
                                        9 ||
                                      allactivity.activitySubType ==
                                        7
                                    ) {
                                      return (
                                        <>
                                          <img src={emaillog} />
                                        </>
                                      );
                                    } else if (
                                      allactivity.activitySubType ==
                                        3 ||
                                      allactivity.activitySubType ==
                                        4 ||
                                      allactivity.activitySubType ==
                                        5
                                    ) {
                                      return (
                                        <>
                                          <img src={phonelog} />
                                        </>
                                      );
                                    } else if (
                                      allactivity.activitySubType ==
                                      12
                                    ) {
                                      return (
                                        <>
                                          <img src={follow} />
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          <img src={notes} />
                                        </>
                                      );
                                    }
                                  })()}
                                </div>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14"> Date : {" "}
                                       <Moment format="D MMM YY">
                                        {allactivity.addedDate}
                                      </Moment>
                                    </h5>
                                     <h5 className="font-size-14"> {
                                        localization[
                                          "ActivitySubType_" +
                                            allactivity.activityType +
                                            "_" +
                                            allactivity.activitySubType
                                        ]
                                      }  {allactivity.activityRefStartDate && (
    <>
      : <Moment format="D MMM YY">{allactivity.activityRefStartDate}</Moment>
    </>
  )} </h5>
                                  </div>
                                 
                                </div>
                                <div className="exNote">
                                  {allactivity.activityRemarks}
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                         ) : (
                          <div className="text-muted text-center py-3">No activity recorded as yet.</div>
                        )}
                      </TabPane>
                     
                      <TabPane tabId="2">
                        <AppointmentLog  />
                      </TabPane>
                      <TabPane tabId="3">
                        <LeadNote />
                      </TabPane>
                     {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                        <TabPane tabId="13">
                          <LeadMessage />
                        </TabPane>
                      )}

                      <TabPane tabId="4">
                        <FollowLead lead={leads} userdetail={userdetail} />
                      </TabPane>
                      <TabPane tabId="5">
                      <Nav
                                    tabs
                                    className="lead-tab mt-10 mb-10 text-center"
                                  >
                                    

                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.ccTab === "1",
                                        })}
                                        onClick={() => {
                                          this.cctoggle("1");
                                        }}
                                      >
                                        <span className="k">
                                          {this.props.t("Call Log")}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.ccTab === "2",
                                        })}
                                        onClick={() => {
                                          this.cctoggle("2");
                                        }}
                                      >
                                        <span className="k">
                                          {this.props.t("Email Log")}
                                        </span>
                                      </NavLink>
                                    </NavItem>      
                                    <NavItem>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          active: this.state.ccTab === "3",
                                        })}
                                        onClick={() => {
                                          this.cctoggle("3");
                                        }}
                                      >
                                        <span className="k">
                                          {this.props.t("SMS Log")}
                                        </span>
                                      </NavLink>
                                    </NavItem>      

                                  
                    </Nav>
                    <TabContent
                      activeTab={this.state.ccTab}
                      className="p-3 text-muted"
                    >
                       <TabPane tabId="1">
                       <CallLog />
                      </TabPane>
                      <TabPane tabId="2">
                      <EmaillLog />
                      </TabPane>
                      <TabPane tabId="3">
                      <SmsLog />
                      </TabPane>
                    </TabContent>
                       
                       
                       
                      </TabPane>
                      <TabPane tabId="6">
                       
                      </TabPane>

                      <TabPane tabId="7">
                        
                      </TabPane>

                      <TabPane tabId="8">
                        <LeadListing lead={leads} />
                      </TabPane>

                    

                    

                      <TabPane tabId="11">
                        <div className="card-title w-100 d-flex justify-content-between align-items-center">
                      <span>Collection</span>
                      <RsAdNew 
                        to="#" 
                        onClick={this.toggleAddCollection} 
                        className="btn btn-light btn-md"  
                        iconClass=""
                      >
                        Add New
                      </RsAdNew>
                    </div>
                        <div className="clearfix"></div>
                        <div className="table-responsive">
                        <Formik
                          initialValues={{
                         
                            agentId: parseInt(localStorage.getItem('userId')),
                            campaignEmailListId:0, 
                            firstName: leads.firstName,
                            lastName: leads.lastName,
                            emailAddress: leads.email,
                            contactNumber: leads.mobile,
                            clientId:0,
                            leadId:parseInt(leads.id),
                            contactId:0,
                            isUnsubscribed:false,
                            isActive:true,
                            checkedItems:[]
                            
                          }}
                          validationSchema={Yup.object().shape({
                            campaignEmailListId: Yup.array().min(1, 'Please select at least one collection')
                          })}
                          //onSubmit={this.handleSubmit}
                        >
                        {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                          <Form className="needs-validation">
                          <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th className="align-middle">
                                  <div className="form-check font-size-16 align-middle"></div>
                                </th>
                                <th className="align-middle">Name</th>
                                <th className="align-middle">Description</th>
                              </tr>
                            </thead>
                            <tbody>
                            {campaignemaillists?.map((campaignemaillist, index) => {
  
                            const isChecked = () => {
                              return camplists?.some(
                                (item) =>
                                  item.campaignEmailListId === campaignemaillist.id &&
                                  !item.isUnsubscribed &&
                                  item.leadId === leads.id
                              );
                              };

                                  return (
                                    <tr key={index}>
                                      <td>
                                        <div className="form-check font-size-16 align-middle">
                                        <input
                                          name={`campaignEmailListItem_${campaignemaillist.id}`}
                                          type="checkbox"
                                          checked={isChecked()} 
                                          onChange={() => {
                                            const obj = JSON.parse(localStorage.getItem("authUser"));
                                            const token = obj?.resultData?.bearerToken;
                                            const str = `Bearer ${token}`;
                                            const currentlyChecked = isChecked();
                                            
                                            const camplistItem = camplists?.find(
                                              (item) =>
                                                item.campaignEmailListId === campaignemaillist.id &&
                                                item.leadId === leads.id
                                            );
                                            const id = camplistItem ? camplistItem.id : 0;
                                            const campaignEmailListItemId = camplistItem ? camplistItem.campaignEmailListItemId : "3fa85f64-5717-4562-b3fc-2c963f66afa6"; 
                                            const requestPayload = {
                                              id,
                                              campaignEmailListItemId, 
                                              campaignEmailListId: campaignemaillist.id, 
                                              agentId: parseInt(values.agentId),
                                              emailAddress: leads.email,
                                              firstName: leads.firstName,
                                              lastName: leads.lastName,
                                              contactNumber: leads.mobile,
                                              clientId:0,
                                              contactId:0,
                                              leadId: parseInt(leads.id),
                                              isUnsubscribed: currentlyChecked,
                                              isActive: true,
                                            };
                                            const apiUrl = `${API_URL}CampaignEmailListItem`; 
                                            const method = camplistItem  ? "put" : "post";
                                            axios({
                                              method,
                                              url: apiUrl,
                                              data: requestPayload,
                                              headers: {
                                                "Content-Type": "application/json",
                                                Authorization: str,
                                              },
                                            })
                                              .then((response) => {
                                                
                                                onGetCampLeadList(localStorage.getItem('userId'),leads.id)
                                              })
                                              .catch((error) => {
                                                console.error('Error during API call:', error);
                                              });
                                          }}
                                          className="form-check-input"
                                          id={`campaignEmailListItem_${campaignemaillist.id}`}
                                        />
                                        <label
                                          htmlFor={`campaign_${campaignemaillist.id}`}
                                          className="form-check-label"
                                        >
                                          &nbsp;
                                        </label>
                                        {touched.campaignEmailListId && errors.campaignEmailListId ? (
                                          <div className="invalid-feedback d-block">
                                            {errors.campaignEmailListId}
                                          </div>
                                        ) : null}
                                      </div>
                                    </td>
                                    <td>{campaignemaillist.campaignEmailListName}</td>
                                    <td>{campaignemaillist.campaignEmailListDesc}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                    
                          {touched.campaignEmailListId && errors.campaignEmailListId ? (
                            <div className="text-danger mt-2">{errors.campaignEmailListId}</div>
                          ) : null}
                          {/* <SaveButton>Submit</SaveButton> */}
                        </Form>
                         
                        )}
                      </Formik>
                        </div>
                      </TabPane>

                            <TabPane tabId="16">
                               <button 
      className="btn btn-light same-size-btn"
      //onClick={this.togglemodal}
       onClick={() => this.setState({ showCompose: true })}
    >
      <i className="bx bx-envelope"></i> Compose
    </button>

                                                 {/* <div className="btn-group me-2 mb-2 mb-sm-0">
                                                                                          
                                                                                                    {selectedEmails.length > 0 && (
                                                                                              <Button type="button" color="primary" onClick={this.handleDelete}>
                                                                                                <i className="far fa-trash-alt" />
                                                                                              </Button>
                                                                                            )}
                                                                                          </div>
                                                    <ul className="message-list">
                                                          {map(inboxMails, (inbox, key) => {
                                                            const createdOnDate = moment(inbox.createdOn);
                                                            const isToday = createdOnDate.isSame(moment(), 'day');
                                                            
                                                            return (
                                                              <li key={key}
                                                                style={
                                                                  Number(inbox.customEmailTemplateId) > 0 
                                                                    ? { backgroundColor: "lavender", color: "black" } 
                                                                    : { backgroundColor: "white", color: "black" }  
                                
                                                                }>
                                                                <div className="col-mail col-mail-1">
                                                                  <div className="checkbox-wrapper-mail">
                                                                    <Input type="checkbox" id={inbox.messageID}
                                                                      onChange={() => this.handleCheckboxChange(inbox.messageID)}
                                                                      checked={selectedEmails.includes(inbox.messageID)}
                                                                    />
                                
                                                                    <Label htmlFor={inbox.messageID} className="toggle" />
                                                                  </div>
                                                                  <Link to={`/email-read/${inbox.emailDetailId}`} className={`title ${inbox.customEmailTemplateId == 0 ? 'has-no-template' : ''}`}>
                                                                    {inbox.from}
                                                                  </Link>
                                                                  {Number(inbox.customEmailTemplateId) > 0 && (
                                                                    <Link className="bg-warning badge  badge-assign me-2 text-white" to={`/email-assign/${inbox.emailDetailId}`}>
                                                                      Assign
                                                                    </Link>
                                                                  )}
                                                                </div>
                                                                <div className={`col-mail col-mail-2 ${inbox.customEmailTemplateId == 0 ? 'has-no-mail' : ''}`}>
                                                                     <SafeHTML html={inbox.subject} />
                                                             
                                                                  <div className="date">
                                                                    {isToday
                                                                      ? createdOnDate.format('h:mm A')
                                                                      : createdOnDate.format('MMM DD')}
                                
                                                                  </div>
                                                                </div>
                                                              </li>
                                                            );
                                                          })}
                                                    </ul> */}
                      
                                                        <EmailActivityList inboxMails={inboxMails} lead={leads} agentData={userdetail} />
                                              </TabPane>
                      
                    </TabContent>
                      ):(
                        <NoAccess />
                      )}
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>



                        <Offcanvas
                              isOpen={this.state.isAddCollection}
                              direction="end"
                              toggle={this.toggleAddCollection}
                            >
                              <OffcanvasHeader toggle={this.toggleAddCollection}>
                                Add New
                              </OffcanvasHeader>
                              <OffcanvasBody>
                              <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                campaignEmailListName: '',
                                                emailListTypeId: 1,
                                                emailListTargetId: '',
                                                campaignEmailListDesc: '',
                                                agentId: parseInt(localStorage.getItem('userId'))
                                            }}
                                            validationSchema={Yup.object().shape({
                                                //emailListTypeId: Yup.string().required("This is required"),
                                                emailListTargetId: Yup.string().required("This is required"),
                                                campaignEmailListName: Yup.string().required("This is required"),
                                            })}
        
                                            onSubmit={this.handleProTypeSubmit}
                                        >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                <Form
                                                    className="needs-validation"
                                                >
                                                    <Row>
        
                                                    {/* <Col sm="12">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="emailListTypeId">
                                                            {this.props.t("List Type")}
                                                            </Label>
                                                            <SafeField as="select" name="emailListTypeId" 
                                                            className={
                                                            "form-control" +
                                                            (errors.emailListTypeId && touched.emailListTypeId
                                                                ? " is-invalid"
                                                                : "")
                                                            }
                                                            
                                                            onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                {map(emaillisttypes, (emaillisttype, classkey) => (
                                                                    <option value={emaillisttype.id} key={classkey}>{emaillisttype.emailListTypeTitle}</option>
                                                                ))}
                                                            </SafeField>
                                                            <ErrorMessage
                                                            name="emailListTypeId"
                                                            component="div"
                                                            className="invalid-feedback"
                                                            />
                                                        </FormGroup>
                                                        </Col> */}
                                                        <Col sm="12">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="emailListTargetId">
                                                            {this.props.t("List Target *")}
                                                            </Label>
                                                            <SafeField as="select" name="emailListTargetId" 
                                                            className={
                                                            "form-control" +
                                                            (errors.emailListTargetId && touched.emailListTargetId
                                                                ? " is-invalid"
                                                                : "")
                                                            }
                                                            
                                                            onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                {map(emaillisttargets, (emaillisttarget, classkey) => (
                                                                    <option value={emaillisttarget.id} key={classkey}>{emaillisttarget.emailListTargetTitle}</option>
                                                                ))}
                                                            </SafeField>
                                                            <ErrorMessage
                                                            name="emailListTargetId"
                                                            component="div"
                                                            className="invalid-feedback"
                                                            />
                                                        </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="campaignEmailListName">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="campaignEmailListName"
                                                                    onChange={handleChange}
        
                                                                    type="text"
        
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.campaignEmailListName && touched.campaignEmailListName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
        
                                                                    id="campaignEmailListName"
                                                                />
                                                                <ErrorMessage
                                                                    name="campaignEmailListName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
        
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="campaignEmailListDesc">
                                                                    {this.props.t("Description")}
                                                                </Label>
                                                                <SafeField
                                                                    name="campaignEmailListDesc"
                                                                    onChange={handleChange}
        
                                                                    type="text"
        
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.campaignEmailListDesc && touched.campaignEmailListDesc
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
        
                                                                    id="campaignEmailListDesc"
                                                                />
                                                                <ErrorMessage
                                                                    name="campaignEmailListDesc"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
        
                                                        </Col>                
                                                        <Col sm="12">
                                                           <SaveButton>Save</SaveButton>
                                                        </Col>
        
                                                    </Row>
                                                </Form>
                                            )}
                                        </Formik>
        
                              </OffcanvasBody>
                 </Offcanvas>




                {showCompose && (
                                <ComposeLeadMail
                                  agentData={userdetail}
                                  lead={leads}
                                  //onSend={this.handleSend}
                                  onClose={() => this.setState({ showCompose: false })}
                                />
                              )}

                

      </React.Fragment>
    );
  }
}
leadDetail.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetLeadDetail: PropTypes.object,
  leads: PropTypes.object,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onConvertLeadToClient: PropTypes.func,
  onCovertLeadIntoContact: PropTypes.func,
  onGetLeadProject:PropTypes.func,
  projects:PropTypes.array,
  campaignemaillists:PropTypes.array,
  onGetCampaignEmailList:PropTypes.func,
  onGetCampLeadList:PropTypes.func,
  camplists:PropTypes.array,
  onGetEmailListTarget: PropTypes.func,
  emaillisttargets: PropTypes.array,
  addCampaignEmailList:PropTypes.func,
  userdetail:PropTypes.object,

};
const mapStateToProps = ({ AppoinmentObject, leads }) =>
  ({
    leads: leads.leads,
    activities: leads.activities,
    projects:leads.projects,
    campaignemaillists:AppoinmentObject.campaignemaillists,
    camplists:leads.camplists,
    emaillisttargets: AppoinmentObject.emaillisttargets,
   
  });
const mapDispatchToProps = dispatch => ({
  onGetLeadDetail: leadId => dispatch(getLeadDetail(leadId)),
  onGetAllActLead: leadId => dispatch(getAllActLeadTab(leadId)),
  onGetEmailListTarget: (agentId) => dispatch(getEmailListTarget(agentId)),
  onConvertLeadToClient: data => dispatch(convertLeadIntoClient(data)),
  onCovertLeadIntoContact: data => dispatch(convertLeadIntoContact(data)),
  onGetLeadProject: leadId => dispatch(getLeadProject(leadId)),
  onGetCampaignEmailList:(agentId) => dispatch(getCampaignEmailList(agentId)),
  onGetCampLeadList:(agentId, LeadId) => dispatch(getCampLeadList(agentId, LeadId)),
  addCampaignEmailList: (data, callback) => dispatch(addCampaignEmailList(data, callback)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(leadDetail));
